import { __decorate } from "tslib";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared';
import { BasketOverviewComponent } from './basket-overview.component';
import { BasketItemComponent } from './basket-item';
import { DeliveryFeeComponent } from './delivery-fee';
import { TotalCostsComponent } from './total-costs';
import { VoucherCodeComponent } from "./voucher-code";
var BasketOverviewModule = /*@__PURE__*/ (function () {
    function BasketOverviewModule() {
    }
    return BasketOverviewModule;
}());
export { BasketOverviewModule };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/modules/basket-overview/basket-overview.module.ts
// module id = null
// module chunks = 